import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import "./css/PopularTourSection.css";

const PopularTourSection = ({ heading }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      const response = await axios.get(
        `https://admin.new.plenaryholidays.com/api/HolidayPackages/domestic_packages`
      );
      if (response) {
        setData(response.data.data);
      }
    };
    dataFetch();
  }, []);

  return (
    <div className="tour-category-sections">
      <div className="trip-category-section pt-120">
        <Container>

          {/* Heading */}
          <Row className="justify-content-center">
            <Col md={6} className="text-center">
              <div className="heading-luxury heading-luxuryIndian">
                <span className="luxury-tag">Top Rated</span>
                <h2>{heading}</h2>
                <p>Handpicked destinations loved by travelers worldwide</p>
              </div>
            </Col>
          </Row>

          {/* Packages Grid */}
          <Row>
            {data.map((item) => (
              <Col lg={3} md={4} sm={6} xs={12} key={item.id} className="mb-4">

                <Link
                  to={`/${item.destination}`}
                  className="trip-category-single"
                >
                  <div className="trip-image" style={{ position: "relative" }}>
                    
                    <img
                      src={item.image}
                      alt={item.name}
                      className="img-fluid"
                      style={{ height: "218px", width: "100%" }}
                    />

                    {/* Overlay */}
                    <div
                      className="image-overlay"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        color: "#fff",
                        background:
                          "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.1))",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        padding: "10px",
                      }}
                    >
                      <div style={{ fontSize: "18px", fontWeight: "600" }}>
                        {item.destination}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "16px",
                          }}
                        >
                          <div style={{fontSize:'10px'}}>Staring from</div>
                          ₹{item.offer_price}
                        </div>

                        <span
                          style={{
                            background: "rgba(3,48,115,0.45)",
                            padding: "5px 12px",
                            borderRadius: "20px",
                          }}
                        >
                          Explore Now <FaChevronRight />
                        </span>
                      </div>
                    </div>

                  </div>
                </Link>

              </Col>
            ))}
          </Row>

        </Container>
      </div>
    </div>
  );
};

export default PopularTourSection;